import { PresentationForm } from 'components/ui/presentation-form/presentation-form';
import './App.css';
import { Layout } from './components/layout';
import { Hero } from './components/ui/hero/hero';
import { About } from 'components/ui/about/about';
import { Advantages } from 'components/ui/advantages/advantages';
import { ApartmentLayouts } from 'components/ui/apartment-layouts/apartment-layouts';
import { ApartmentsFinishing } from 'components/ui/apartments-finishing/apartments-finishing';
import { Infrastructure } from 'components/ui/infrastructure/infrastructure';
import { NewMoscow } from 'components/ui/new-moscow/new-moscow';
import { Finishing } from 'components/ui/finishing/finishing';
import { Parking } from 'components/ui/parking/parking';
import { MapRoutes } from 'components/ui/map-routes/map-routes';
import { Payments } from 'components/ui/payments/payments';
import { Builder } from 'components/ui/builder/builder';
import { Contacts } from 'components/ui/contacts/contacts';
import YandexMapWithFilters from 'components/ui/yandex-map-with-filters/yandex-map-with-filters';
import { BuildingProgress } from 'components/ui/building-progress/building-progress';
import Consent from "./components/ui/consent/consent";
import { MarquizBtn } from "./components/ui/marquiz-btn/marquiz-btn";
import { ThirdPartyScripts } from "./components/ui/third-party-scripts/third-party-scripts";

function App() {
  return (
    <div className="App relative">
      <Layout.Header />
      <Hero />
      <PresentationForm />
      <About />
      <Advantages />
      <ApartmentLayouts />
      <Infrastructure />
      <YandexMapWithFilters />
      <NewMoscow />
      <ApartmentsFinishing />
      <Finishing />
      <Parking />
      <MapRoutes />
      <Payments />
      {/* <BuildingProgress/> */}
      <Builder />
      <Contacts />
      <Layout.Footer />
      <Consent />
      <MarquizBtn />
      <ThirdPartyScripts />
    </div>
  );
}

export default App;
